package com.mps.asc_app.data.config

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

@OptIn(ExperimentalTime::class)
class ConfigRepositoryImpl : ConfigRepository {

    private val db = Firebase.firestore

    override suspend fun getTimeslotConfig(): TimeslotConfig {
        val snap = db.collection("config").document("timeslots").get()

        val bookingEnabled = snap.get<Boolean?>("bookingEnabled") ?: true
        val bookingNamesPublic = snap.get<Boolean?>("bookingNamesPublic")
            ?: snap.get<Boolean?>("namesPublic")
            ?: true
        val bookingOpenAtMillis: Instant? = null
        val start = snap.get<String?>("start") ?: "10:00"
        val end = snap.get<String?>("end") ?: "22:00"
        val interval = (snap.get<Long?>("interval") ?: 60L).toInt()

        return TimeslotConfig(
            bookingEnabled = bookingEnabled,
            bookingOpenAt = bookingOpenAtMillis,
            bookingNamesPublic = bookingNamesPublic,
            start = start,
            end = end,
            intervalMinutes = interval
        )
    }

    override suspend fun setBookingNamesPublic(enabled: Boolean): Result<Unit> = runCatching {
        db.collection("config").document("timeslots")
            .set(mapOf("bookingNamesPublic" to enabled), merge = true)
    }
}